<template>
    <Section 
        v-if="jumpLinks.length"
        :width="sectionWidth" 
        class="table-of-contents"
    >
        <Expand 
            :button="expanderButtonText"
            class="contents-expander"
        >
            <ul class="contents-wrapper">
                <li v-for="(jumpLink, index) in jumpLinks" :key="index">
                    <a 
                        v-scroll-to="{
                            el: jumpLink.id,
                            offset: -100
                        }" 
                        href="#"
                    >
                        {{ jumpLink.linkText }}
                    </a>
                </li>
            </ul>
        </Expand>
    </Section>
</template>

<script>
import Expand from '@/components/slices/list/list-item/list-item-components/Expand.vue';
export default {
    components: {
        Expand
    },
    props: {
        slice: {
            type: Object,
            required: true
        },
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        sectionWidth() {
            return this.slice.primary.slice_width ?? 'sm';
        },
        jumpLinks() {
            return this.slicesOnDocument
                .filter(slice => slice.slice_type === 'table_of_contents_link' && this.$validateText(slice.primary.link_text))
                .map(slice => {
                    return {
                        id: `#${slice.id.replaceAll('$', '-')}`,
                        linkText: slice.primary.link_text
                    };
                });
        },
        expanderButtonText() {
            return this.$validateText(this.slice.primary.expander_button_text) 
                ? this.slice.primary.expander_button_text 
                : this.$translate('table_of_contents_expander_button_text', 'Sidans innehåll');
        },
        slicesOnDocument() {
            return this.document.data.body;
        },
    }
};
</script>

<style lang='scss' scoped>
    .table-of-contents::v-deep {
        @include spacing(padding,0,(top, bottom));
        @include spacing(margin,4,top);
        @include font-size(14px,8px);
        .contents-expander {
            .expand-row__button {
                justify-content: flex-start;
                @include spacing(padding,0,top);
                width: fit-content;
            }
            .contents-wrapper {
                background-color: $graybg;
                @include border-radius(10px);
                @include spacing(padding, 3);
                @include device(pad) {
                    @include spacing(padding, 4, (left, right));
                }
                li {
                    @include spacing(padding,1,(top,bottom));
                    font-weight: bold;
                    a {
                        display: block;
                        &:hover {
                            color: $green;
                        }
                    }
                }
            }
        }
    }
</style>